<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import LoadingMessage from '../LoadingMessage.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';

export default {
    components: { Layout, PageHeader, LoadingMessage ,vSelect },
    data() {
        return {
            title: "COTIZACIONES",
            items: [{ text: "Documentos", href: "/" }, { text: "Cotizaciones", active: true }],
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10,20, 50, 100],
            filter: null,
            filterOn: ['id','numerosl','numeropw', 'cliente'],
            sortBy: "created_at",
            sortDesc: true,
            filter: '',
            Cotizacion: {
                nombre: '',
                cliente: '',
                cliente_id: '',
                vendedor: '',
                vendedor_id: '',
                fecha: '',
                estado: '',
                contacto: '',
                mail: '',
                condicionVenta: '',
                descripcion: '',
                productos: [],
                totalNeto: 0,
                iva: 0,
                total: 0,
                id: null,
                rut: '',
            },

            fields: [
                {
                    key: "numeropw",
                    label: "#",
                    sortable: true,
                    thStyle: { width: "7%" }
                },
                {
                    key: "numerosl",
                    label: "ID Softland",
                    sortable: true,
                    thStyle: { width: "9%" }
                },
                {
                    key: "cliente",
                    label: "Cliente",
                    sortable: true,
                    thStyle: { width: "35%" }
                },
                {
                    key: "vendedor",
                    label: "Vendedor",
                    sortable: true,
                    thStyle: { width: "20%" }
                },
                {
                    key: "total",
                    label: "Total",
                    sortable: true,
                    thStyle: { width: "8%" },
                },
                {
                    key: "accion",
                    label: "Acciones",
                    thStyle: { width: "19%" },
                    tdClass: "text-center"
                }
                ],
            cotizaciones: [],
            ws_clientes: [],
            ws_productos: [],
            saldo_pendiente: 0,
            verFacturas: false,
            facturas_pendientes: [],
            windowWidth2: window.innerWidth,
            windowHeight2: window.innerHeight,
        };
    },
    computed: {
        rows() {
            return this.totalRows;
        }
    },
    watch: {
        'Cotizacion.cliente'(cliente) {
            if (!cliente || !cliente.CodAux) return;
                axios.get(`/api/saldo_pendiente/${cliente.CodAux}`).then(res => {
                    this.saldo_pendiente = res.data.saldo_pendiente;
                    this.facturas_pendientes = res.data.facturas_pendientes;
                }).catch(() => {
                this.saldo_pendiente = 0;
            });
        }
    },
    methods: {
        onClienteSeleccionado(cliente) {
            // Aquí haces lo que necesites con el cliente seleccionado
            console.log('Cliente seleccionado:', cliente);
            // Por ejemplo, podrías cargar sus mascotas o condiciones
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        formatPrecio(valor) {
            if (!valor && valor !== 0) return '';
            return Number(valor).toLocaleString('es-CL');
        },
        limpiarNumero(valor) {
            return valor.toString().replace(/\$/g, '').replace(/\./g, '');
        },
        limitarDescuento(item) {
            let valor = item.DescU.toString().replace(/[^\d]/g, ''); // quita todo lo que no sea dígito
            valor = parseInt(valor) || 0;

            if (valor > 100) valor = 0;

            item.DescU = valor;
        },

        quitarProductoPorItem(item) {
        const index = this.Cotizacion.productos.indexOf(item);
        if (index !== -1) {
            this.Cotizacion.productos.splice(index, 1);
        }
        },
        actualizarTotalesPorPorducto() {
            this.Cotizacion.productos.forEach(p => {
                p.total = this.total_venta(p.cantidad, p.precio_unitario, p.DescU);
            });
        },

        guardar_cotizacion(){
            //console.log(this.Cotizacion)
            this.Cotizacion.productos.forEach(p => {//actualiza totales por producto
                p.total = this.total_venta(p.cantidad, p.precio, p.DescU);
            });
            this.Cotizacion.cliente_id=this.Cotizacion.cliente.id
            this.Cotizacion.nombre=this.Cotizacion.cliente.NomAux
            this.Cotizacion.estado=this.Cotizacion.cliente.Bloqueado!='N'?'Bloqueado':'Habilitado'
            this.Cotizacion.condicionVenta=this.Cotizacion.cliente.CondicionVenta
            this.Cotizacion.estado=this.Cotizacion.cliente.Bloqueado!='N'?'Bloqueado':'Habilitado'
            this.Cotizacion.total=this.limpiarNumero(this.totalConIva)
            this.Cotizacion.totalNeto=this.limpiarNumero(this.totalNeto)
            this.Cotizacion.iva=this.limpiarNumero(this.totalIva)
            console.log(this.Cotizacion)
            if(this.Cotizacion.productos.length>0){
                axios.post('/api/guardar_cotizacion', this.Cotizacion)
                .then(res => {
                    if (res.data.estado) {
                        this.$toasted.success(res.data.message);
                        this.cotizaciones=res.data.cotizaciones;
                        this.$refs.ModalCrearCotizacion.hide();
                    } else {
                        this.$toasted.error(res.data.mensaje || 'Error al guardar cotización');
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.$toasted.error('Error del servidor al guardar cotización');
                });
            }else{
                this.$toasted.error('Sin productos asociados.');
            }
        },
        CrearCotizacion() {
            this.Cotizacion.id = null;
            this.Cotizacion.nombre = '';
            this.Cotizacion.cliente = '';
            this.Cotizacion.cliente_id = '';
            this.Cotizacion.condicion = '';
            this.Cotizacion.fecha = new Date().toISOString().slice(0, 10);
            this.Cotizacion.contacto = '';
            this.Cotizacion.estado = '';
            this.Cotizacion.condicionVenta= '';
            this.Cotizacion.mail = '';
            this.Cotizacion.descripcion = '';
            this.Cotizacion.totalNeto = 0;
            this.Cotizacion.iva = 0;
            this.Cotizacion.total = 0;

            this.Cotizacion.productos = [
                {
                    producto: '',
                    cantidad: 0,
                    precio: 0,
                    total: 0,
                    DescU: 0,
                }
            ];
            // console.log(this.Cotizacion)
            this.$refs.ModalCrearCotizacion.show();
        },
        EditarCotizacion(item) {
            // Clona toda la cotización base
            const base = JSON.parse(JSON.stringify(item));

            base.numeropw = null;
            base.fecha = new Date().toISOString().slice(0, 10);
            base.totalNeto = 0;
            base.iva = 0;
            base.total = 0;

            // Re-mapea los productos con estructura correcta
            base.productos = (base.productos || []).map(prod => {
                let productoRef = prod.producto || prod; // prod.producto es el objeto si existe, si no, todo prod es el objeto
                let codigo = productoRef.CodProd || prod.codigo || '';
                // Busca el producto en tu ws_productos por código para referencia real (opcional, pero recomendable)
                const ref = this.ws_productos.find(p => p.CodProd === codigo) || {};
                return {
                    codigo,
                    producto: ref, // El objeto de producto completo desde ws_productos
                    cantidad: prod.cantidad || 1,
                    precio: prod.precio || prod.precio_unitario || ref.PrecioVta || 0,
                    total: 0,
                    DescU: prod.DescU || 0,
                };
            });
            // Si no hay productos, deja uno vacío
            if (!base.productos.length) {
                base.productos = [{
                    codigo: '',
                    producto: '',
                    cantidad: 1,
                    precio: 0,
                    total: 0,
                    DescU: 0,
                }];
            }
            this.Cotizacion = base;
            this.$refs.ModalCrearCotizacion.show();
        },
        CopiarCotizacion(item) {
            // Clona toda la cotización base
            const base = JSON.parse(JSON.stringify(item));

            base.id = null;
            base.numeropw = null;
            base.numerosl = null;
            base.fecha = new Date().toISOString().slice(0, 10);
            base.totalNeto = 0;
            base.iva = 0;
            base.total = 0;

            // Re-mapea los productos con estructura correcta
            base.productos = (base.productos || []).map(prod => {
                let productoRef = prod.producto || prod; // prod.producto es el objeto si existe, si no, todo prod es el objeto
                let codigo = productoRef.CodProd || prod.codigo || '';
                // Busca el producto en tu ws_productos por código para referencia real (opcional, pero recomendable)
                const ref = this.ws_productos.find(p => p.CodProd === codigo) || {};
                return {
                    codigo,
                    producto: ref, // El objeto de producto completo desde ws_productos
                    cantidad: prod.cantidad || 1,
                    precio: prod.precio || prod.precio_unitario || ref.PrecioVta || 0,
                    total: 0,
                    DescU: prod.DescU || 0,
                };
            });
            // Si no hay productos, deja uno vacío
            if (!base.productos.length) {
                base.productos = [{
                    codigo: '',
                    producto: '',
                    cantidad: 1,
                    precio: 0,
                    total: 0,
                    DescU: 0,
                }];
            }
            this.Cotizacion = base;
            this.Cotizacion.vendedor_id = this.user.id;
            this.Cotizacion.vendedor = this.user;
            this.$refs.ModalCrearCotizacion.show();
        },

        agregarProducto() {
            this.Cotizacion.productos.push({
                codigo: '',
                producto: '',
                cantidad: 0,
                precio: 0,
                total: 0,
                DescU: 0,
            });
            // console.log(this.Cotizacion)
        },
        quitarProducto(index) {
            this.Cotizacion.productos.splice(index-1, 1);
        },
        verCotizacion(item) {
            //console.log(item)
            this.Cotizacion = JSON.parse(JSON.stringify(item));
            // console.log(this.Cotizacion)
            this.$refs.ModalVerCotizacion.show();
        },
        productoSeleccionado(index, producto) {
            if (producto) {
                this.Cotizacion.productos[index].producto = producto; // guarda el objeto completo
                this.Cotizacion.productos[index].codigo = producto.CodProd;
                this.Cotizacion.productos[index].precio = producto.PrecioVta || 0;
                this.Cotizacion.productos[index].cantidad = 1;
            }
        },

        total_venta(cantidad, precio, descuento = 0) {
            const totalBruto = (parseInt(cantidad) || 0) * (parseInt(precio) || 0);
            const descuentoAplicado = (parseInt(descuento) || 0) / 100;
            const totalConDescuento = totalBruto * (1 - descuentoAplicado);
            return Math.round(totalConDescuento);
        },
exportarPDF() {
    const doc = new jsPDF('p', 'mm', 'a4');
    const marginX = 15;
    let cursorY = 15;

    const morado = '#21308F';
    const bold = 'bold';

    // --- CABECERA ---
    // Agregamos la imagen con compresión JPEG calidad 0.5 y tamaño menor
    // Necesitamos cargar la imagen como base64 antes. Si usas url, es mejor convertirla.
    // Aquí asumo que tienes la imagen en base64 o un método para convertirla.
    // Como alternativa, si no tienes base64, el addImage acepta URL pero sin compresión.
    // Por simplicidad aquí usamos addImage con calidad 0.5 y menor tamaño.
    doc.addImage('/archivos_base/logo.png', 'JPEG', marginX, cursorY, 30, 12, undefined, 'FAST', 0.5);

    doc.setFontSize(10);
    doc.setTextColor(morado);
    doc.text('Teléfono: 63 2 219881 - 63 2 204385', marginX, cursorY + 20);
    doc.text('Dirección: Errázuriz 2066, Valdivia', marginX, cursorY + 25);
    doc.text('Email: contacto@vamproden.cl', marginX, cursorY + 30);
    doc.text('Web: www.vamproden.cl', marginX, cursorY + 35);

    doc.setFontSize(11);
    doc.setFont(undefined, bold);
    doc.text(`ID: ${this.Cotizacion.numerosl}`, 145, cursorY + 20);
    doc.text(`Número Cotización: COT${this.Cotizacion.id}`, 145, cursorY + 25);
    doc.text(`Fecha Creación: ${this.Cotizacion.fecha}`, 145, cursorY + 30);

    cursorY += 45;

    // --- DETALLE CLIENTE/VENDEDOR ---
    doc.setDrawColor(morado);
    doc.setFontSize(12);
    doc.setFont(undefined, bold);
    doc.text('Detalle de Cotización', marginX, cursorY);
    cursorY += 6;

    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');

    doc.text(`Cliente: ${this.Cotizacion.cliente.NomAux}`, marginX, cursorY); cursorY += 5;
    doc.text(`Rut: ${this.Cotizacion.cliente.CodAux}`, marginX, cursorY); cursorY += 5;

    if (this.Cotizacion.cliente.CondicionVenta) {
        doc.text(`Condición de Venta: ${this.Cotizacion.cliente.CondicionVenta}`, marginX, cursorY);
        cursorY += 5;
    }

    if (this.Cotizacion.cliente.Email) {
        doc.text(`Correo: ${this.Cotizacion.cliente.Email}`, marginX, cursorY);
        cursorY += 5;
    }

    if (this.Cotizacion.vendedor?.name) {
        doc.text(`Vendedor: ${this.Cotizacion.vendedor.name}`, 110, cursorY - 15);
    }

    if (this.Cotizacion.descripcion) {
        doc.text(`Descripción: ${this.Cotizacion.descripcion}`, 110, cursorY - 10);
    }

    // --- TABLA ---
    const columns = [
        { header: 'N', dataKey: 'n' },
        { header: 'Código', dataKey: 'codigo' },
        { header: 'Producto', dataKey: 'producto' },
        { header: 'Cant', dataKey: 'cantidad' },
        { header: 'P. Unitario', dataKey: 'precio_unitario' },
        { header: '%', dataKey: 'desc' },
        { header: 'Total', dataKey: 'total' }
    ];

    const rows = this.Cotizacion.productos.map((item, index) => ({
        n: index + 1,
        codigo: item.codigo,
        producto: item.producto?.DesProd || item.producto || '',
        cantidad: item.cantidad,
        precio_unitario: this.formatPrecio(parseInt(item.precio_unitario)),
        desc: item.DescU,
        total: this.formatPrecio(parseInt(item.total))
    }));

    autoTable(doc, {
        startY: cursorY + 5,
        margin: { left: marginX, right: marginX },
        head: [columns.map(c => c.header)],
        body: rows.map(row => columns.map(col => row[col.dataKey])),
        styles: {
            fontSize: 9,
            textColor: '#000',
            lineColor: morado,
            lineWidth: 0.3
        },
        headStyles: {
            fillColor: [231, 243, 255],
            textColor: [33, 48, 143],
            halign: 'center'
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            halign: 'center',
            valign: 'middle'
        },
        columnStyles: {
            0: { cellWidth: 10 },
            1: { cellWidth: 22 },
            2: { cellWidth: 83, halign: 'left' },
            3: { cellWidth: 12 },
            4: { cellWidth: 20 },
            5: { cellWidth: 10 },
            6: { cellWidth: 23 }
        }
    });

    let finalY = doc.lastAutoTable.finalY + 10;

    const pageHeight = doc.internal.pageSize.height;
    const espacioNecesario = 50;
    const espacioRestante = pageHeight - finalY;

    if (espacioRestante < espacioNecesario) {
        doc.addPage();
        finalY = 15;
    }

    // --- RESUMEN ---
    doc.setFont(undefined, bold);
    doc.setFontSize(10);
    doc.text('Datos de transferencia:', marginX, finalY);
    doc.setFont(undefined, 'normal');
    doc.text('Vamproden SpA', marginX, finalY + 5);
    doc.text('76.962.948-3', marginX, finalY + 10);
    doc.text('Banco Santander', marginX, finalY + 15);
    doc.text('Cuenta Corriente: 73686610', marginX, finalY + 20);
    doc.text('nfigueroa@vamproden.cl', marginX, finalY + 25);
    doc.setFont(undefined, 'bold');
    doc.text('Link Webpay:', marginX, finalY + 35);
    doc.setFont(undefined, 'normal');
    doc.text('https://www.webpay.cl/company/27935', marginX, finalY + 40);

    // Totales con fondo celeste claro
    doc.setFillColor(231, 243, 255);
    doc.rect(125, finalY + 2, 70, 20, 'F');

    doc.setFont(undefined, bold);
    doc.text(`Total Neto: ${this.formatPrecio(this.Cotizacion.total_neto)}`, 130, finalY + 8);
    doc.text(`IVA: ${this.formatPrecio(this.Cotizacion.iva)}`, 130, finalY + 13);
    doc.text(`Total Cotización: ${this.formatPrecio(this.Cotizacion.total)}`, 130, finalY + 18);

    // --- Guardar PDF ---
    doc.save(`Cotizacion_${this.Cotizacion.cliente.CodAux}_${new Date().toISOString().slice(0, 10)}.pdf`);
},

        
async enviarPDFCotizacion(info, correo, correoGuardar) {
    this.isLoading = true;

    const doc = new jsPDF('p', 'mm', 'a4');
    const marginX = 15;
    let cursorY = 15;

    const morado = '#21308F';
    const bold = 'bold';

    // --- CABECERA ---
    // Agrega logo como JPEG con compresión baja si tienes base64, aquí se usa PNG sin compresión (ajusta si quieres base64 y calidad)
    doc.addImage('/archivos_base/logo.png', 'JPEG', marginX, cursorY, 30, 12, undefined, 'FAST', 0.5);

    doc.setFontSize(10);
    doc.setTextColor(morado);
    doc.text('Teléfono: 63 2 219881 - 63 2 204385', marginX, cursorY + 20);
    doc.text('Dirección: Errázuriz 2066, Valdivia', marginX, cursorY + 25);
    doc.text('Email: contacto@vamproden.cl', marginX, cursorY + 30);
    doc.text('Web: www.vamproden.cl', marginX, cursorY + 35);

    doc.setFontSize(11);
    doc.setFont(undefined, bold);
    doc.text(`ID: ${this.Cotizacion.numerosl}`, 145, cursorY + 20);
    doc.text(`Número Cotización: COT${this.Cotizacion.id}`, 145, cursorY + 25);
    doc.text(`Fecha Creación: ${this.Cotizacion.fecha}`, 145, cursorY + 30);

    cursorY += 45;

    // --- DETALLE CLIENTE/VENDEDOR ---
    doc.setDrawColor(morado);
    doc.setFontSize(12);
    doc.setFont(undefined, bold);
    doc.text('Detalle de Cotización', marginX, cursorY);
    cursorY += 6;

    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');

    doc.text(`Cliente: ${this.Cotizacion.cliente.NomAux}`, marginX, cursorY); cursorY += 5;
    doc.text(`Rut: ${this.Cotizacion.cliente.CodAux}`, marginX, cursorY); cursorY += 5;

    if (this.Cotizacion.cliente.CondicionVenta) {
        doc.text(`Condición de Venta: ${this.Cotizacion.cliente.CondicionVenta}`, marginX, cursorY);
        cursorY += 5;
    }

    if (this.Cotizacion.cliente.Email) {
        doc.text(`Correo: ${this.Cotizacion.cliente.Email}`, marginX, cursorY);
        cursorY += 5;
    }

    if (this.Cotizacion.vendedor?.name) {
        doc.text(`Vendedor: ${this.Cotizacion.vendedor.name}`, 110, cursorY - 15);
    }

    if (this.Cotizacion.descripcion) {
        doc.text(`Descripción: ${this.Cotizacion.descripcion}`, 110, cursorY - 10);
    }

    // --- TABLA ---
    const columns = [
        { header: 'N', dataKey: 'n' },
        { header: 'Código', dataKey: 'codigo' },
        { header: 'Producto', dataKey: 'producto' },
        { header: 'Cant', dataKey: 'cantidad' },
        { header: 'P. Unitario', dataKey: 'precio_unitario' },
        { header: '%', dataKey: 'desc' },
        { header: 'Total', dataKey: 'total' }
    ];

    const rows = this.Cotizacion.productos.map((item, index) => ({
        n: index + 1,
        codigo: item.codigo,
        producto: item.producto?.DesProd || item.producto || '',
        cantidad: item.cantidad,
        precio_unitario: this.formatPrecio(parseInt(item.precio_unitario)),
        desc: item.DescU,
        total: this.formatPrecio(parseInt(item.total))
    }));

    autoTable(doc, {
        startY: cursorY + 5,
        margin: { left: marginX, right: marginX },
        head: [columns.map(c => c.header)],
        body: rows.map(row => columns.map(col => row[col.dataKey])),
        styles: {
            fontSize: 9,
            textColor: '#000',
            lineColor: morado,
            lineWidth: 0.3
        },
        headStyles: {
            fillColor: [231, 243, 255],
            textColor: [33, 48, 143],
            halign: 'center'
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            halign: 'center',
            valign: 'middle'
        },
        columnStyles: {
            0: { cellWidth: 10 },
            1: { cellWidth: 22 },
            2: { cellWidth: 83, halign: 'left' },
            3: { cellWidth: 12 },
            4: { cellWidth: 20 },
            5: { cellWidth: 10 },
            6: { cellWidth: 23 }
        }
    });

    let finalY = doc.lastAutoTable.finalY + 10;

    const pageHeight = doc.internal.pageSize.height;
    const espacioNecesario = 50;
    const espacioRestante = pageHeight - finalY;

    if (espacioRestante < espacioNecesario) {
        doc.addPage();
        finalY = 15;
    }

    // --- RESUMEN ---
    doc.setFont(undefined, bold);
    doc.setFontSize(10);
    doc.text('Datos de transferencia:', marginX, finalY);
    doc.setFont(undefined, 'normal');
    doc.text('Vamproden SpA', marginX, finalY + 5);
    doc.text('76.962.948-3', marginX, finalY + 10);
    doc.text('Banco Santander', marginX, finalY + 15);
    doc.text('Cuenta Corriente: 73686610', marginX, finalY + 20);
    doc.text('nfigueroa@vamproden.cl', marginX, finalY + 25);
    doc.setFont(undefined, 'bold');
    doc.text('Link Webpay:', marginX, finalY + 35);
    doc.setFont(undefined, 'normal');
    doc.text('https://www.webpay.cl/company/27935', marginX, finalY + 40);

    // Totales con fondo celeste claro
    doc.setFillColor(231, 243, 255);
    doc.rect(125, finalY + 2, 70, 20, 'F');

    doc.setFont(undefined, bold);
    doc.text(`Total Neto: ${this.formatPrecio(this.Cotizacion.total_neto)}`, 130, finalY + 8);
    doc.text(`IVA: ${this.formatPrecio(this.Cotizacion.iva)}`, 130, finalY + 13);
    doc.text(`Total Cotización: ${this.formatPrecio(this.Cotizacion.total)}`, 130, finalY + 18);

    // --- Obtener blob y enviar ---
    const pdfBlob = doc.output('blob');

    const formData = new FormData();
    formData.append('file', pdfBlob, `Cotizacion_${info.id || 'sin_id'}.pdf`);
    formData.append('email', correo);
    formData.append('nombre', info.cliente.NomAux || 'Cliente');
    formData.append('total', info.total);
    formData.append('id', info.id || 0);
    formData.append('rut', info.cliente.CodAux || '');
    formData.append('guardarCorreo', correoGuardar || false);

    try {
        const response = await axios.post('/cotizacion_email_send', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        const mensaje = response.data.message || 'Correo enviado exitosamente';
        this.$bvToast.toast(mensaje, {
            title: 'Éxito',
            variant: 'success',
            solid: true
        });
    } catch (error) {
        const mensaje = error.response?.data?.message || 'Error al enviar el correo';
        this.$bvToast.toast(mensaje, {
            title: 'Error',
            variant: 'danger',
            solid: true
        });
    } finally {
        this.isLoading = false;
    }
},



        
        // async generarPDF() {
        //     const header = this.$refs.cotizacionHeader;
        //     const detalle = this.$refs.detalleCotizacion; // el contenedor del detalle que solo se muestra en la 1ra página
        //     const tabla = this.$refs.cotizacionTabla;
        //     const resumen = tabla.parentElement.querySelector('.resumen-cotizacion'); // pie de página

        //     const rows = tabla.querySelectorAll("tbody tr");
        //     const totalProductos = this.Cotizacion.productos.length;

        //     // Definimos límites según cantidad de productos
        //     // Ajusta valores para mejor distribución
        //     let primeraPaginaLimite = 12; // por ejemplo, hasta 20 en la 1ra página
        //     let filasPorPagina = 25; // 25 filas en páginas siguientes

        //     // Si hay pocos productos, todo en 1 página
        //     if (totalProductos <= primeraPaginaLimite) {
        //         filasPorPagina = 0; // no hay páginas extra
        //     }

        //     // Número de filas restantes después de la primera página
        //     const filasRestantes = totalProductos > primeraPaginaLimite ? totalProductos - primeraPaginaLimite : 0;
        //     const paginasAdicionales = filasPorPagina > 0 ? Math.ceil(filasRestantes / filasPorPagina) : 0;
        //     const totalPaginas = 1 + paginasAdicionales;

        //     const pdf = new jsPDF('p', 'mm', 'a4');
        //     const anchoPDF = pdf.internal.pageSize.getWidth();

        //     for (let i = 0; i < totalPaginas; i++) {
        //         // Mostrar header y detalle sólo en la primera página
        //         if (header) header.style.display = i === 0 ? '' : 'none';
        //         if (detalle) detalle.style.display = i === 0 ? '' : 'none';
        //         rows.forEach(r => (r.style.display = 'none'));

        //         if (i === 0) {
        //             // Mostrar filas de la primera página
        //             for (let j = 0; j < primeraPaginaLimite && j < rows.length; j++) {
        //                 rows[j].style.display = '';
        //             }
        //         } else {
        //             // Mostrar filas de páginas adicionales
        //             const inicio = primeraPaginaLimite + (i - 1) * filasPorPagina;
        //             const fin = inicio + filasPorPagina;
        //             for (let j = inicio; j < fin && j < rows.length; j++) {
        //                 rows[j].style.display = '';
        //             }
        //         }

        //         // Pie de página sólo en la última página
        //         if (resumen) resumen.style.display = i === totalPaginas - 1 ? '' : 'none';

        //         // Esperar que el DOM se actualice y luego capturar la imagen
        //         await this.$nextTick();

        //         const canvas = await html2canvas(this.$refs.CotizacionContentPDF, {
        //             scale: 1.5,
        //             useCORS: true,
        //             scrollX: 0,
        //             scrollY: -window.scrollY
        //         });

        //         const imgData = canvas.toDataURL('image/jpeg', 0.7);
        //         const imgProps = pdf.getImageProperties(imgData);
        //         const pdfHeight = (imgProps.height * anchoPDF) / imgProps.width;

        //         if (i !== 0) pdf.addPage();
        //         pdf.addImage(imgData, 'JPEG', 0, 0, anchoPDF, pdfHeight, undefined, 'FAST');
        //     }

        //     // Restaurar visibilidad original
        //     rows.forEach(r => (r.style.display = ''));
        //     if (header) header.style.display = '';
        //     if (detalle) detalle.style.display = '';
        //     if (resumen) resumen.style.display = '';

        //     pdf.save(`Cotizacion_${this.Cotizacion.cliente.CodAux}_${new Date().toISOString().slice(0, 10)}.pdf`);
        // },

        async consultaCorreoCotizacion(info) {
            this.$refs.ModalVerCotizacion.hide();
            try {
                const correoExistente = info.cliente.Email || "";
                const { value: email, isConfirmed } = await Swal.fire({
                    title: "Enviar Cotización",
                    input: "email",
                    inputValue: correoExistente,
                    inputLabel: "Confirma o ingresa el correo del cliente",
                    inputPlaceholder: "correo@example.com",
                    showCancelButton: true,
                    confirmButtonText: "Enviar",
                    confirmButtonColor: "#2b2e8f",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true,
                    inputValidator: value => {
                        if (!value) return "Debe ingresar un correo válido.";
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailRegex.test(value)) return "El formato del correo no es válido.";
                    }
                });

                if (isConfirmed) {
                    const confirmacion = await Swal.fire({
                        title: "Confirmar Envío",
                        html: `
                            <p>¿Deseas enviar la cotización al correo: <strong>${email}</strong>?</p>
                            <div>
                                <input type="checkbox" id="guardarCorreo">
                                <label for="guardarCorreo">Guardar correo para cliente</label>
                            </div>
                        `,
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonText: "Sí, enviar",
                        confirmButtonColor: "#2b2e8f",
                        cancelButtonText: "Cancelar",
                        reverseButtons: true,
                        preConfirm: () => {
                            return {
                                guardarCorreo: document.getElementById("guardarCorreo").checked
                            };
                        }
                    });

                    this.$refs.ModalVerCotizacion.show();

                    if (confirmacion.isConfirmed) {
                        setTimeout(() => {
                            this.enviarPDFCotizacion(info, email,confirmacion.value.guardarCorreo);
                        }, 100);
                    }
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: "error",
                    title: "Ocurrió un problema al procesar la solicitud.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#2b2e8f"
                });
            }
        },
    },
    computed: {
        totalNeto() {
            this.actualizarTotalesPorPorducto();
            const total = this.Cotizacion.productos.reduce((sum, prod) => {
            const cantidad = parseFloat(prod.cantidad) || 0;
            const precio = parseFloat(prod.precio) || 0;
            const descuento = parseFloat(prod.DescU) || 0;
            const totalConDescuento = cantidad * precio * (1 - descuento / 100);
            return sum + totalConDescuento;
            }, 0);
            return '$' + Math.round(total).toLocaleString('es-CL');
        },
        totalIva() {
            this.actualizarTotalesPorPorducto();
            const neto = this.Cotizacion.productos.reduce((sum, prod) => {
            const cantidad = parseFloat(prod.cantidad) || 0;
            const precio = parseFloat(prod.precio) || 0;
            const descuento = parseFloat(prod.DescU) || 0;
            const totalConDescuento = cantidad * precio * (1 - descuento / 100);
            return sum + totalConDescuento;
            }, 0);
            const iva = neto * 0.19;
            return '$' + Math.round(iva).toLocaleString('es-CL');
        },
        totalConIva() {
            this.actualizarTotalesPorPorducto();
            const neto = this.Cotizacion.productos.reduce((sum, prod) => {
            const cantidad = parseFloat(prod.cantidad) || 0;
            const precio = parseFloat(prod.precio) || 0;
            const descuento = parseFloat(prod.DescU) || 0;
            const totalConDescuento = cantidad * precio * (1 - descuento / 100);
            return sum + totalConDescuento;
            }, 0);
            const total = neto * 1.19;
            return '$' + Math.round(total).toLocaleString('es-CL');
        }
    },

    mounted() {
        this.isLoading=true
        axios.get('/api/get_cotizaciones').then(r => {
            this.cotizaciones = r.data
            this.totalRows = this.cotizaciones.length
        });
        this.Cotizacion.vendedor_id = this.user.id;
        this.Cotizacion.vendedor = this.user;
        axios.get('/api/get_ws_clientes').then(res=>{
			this.ws_clientes=res.data.ws_clientes;
			this.isLoading=false;
		});
        axios.get('/api/get_ws_productos').then(res=>{
			this.ws_productos=res.data.ws_productos;
		});
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message  v-if="isLoading" />
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <div class="card-body">
                        <div class="row pr-1">
                            <div class="col-10">
                                <h4 class="card-title">Cotizaciones</h4>
                            </div>
                            <div class="col-2 mb-2">
                                <b-button variant="primary" class="float-right" @click="CrearCotizacion">Nueva Cotización</b-button>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-4">
                                <b-form-input v-model="filter" placeholder="Buscar..."></b-form-input>
                            </div>
                            <div id="tickets-table_length" class="dataTables_length">
                                <label class="d-inline-flex align-items-center">
                                    Mostrar&nbsp;
                                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                                </label>
                            </div>
                        </div>
                        
                        <div class="table-responsive mb-0">
                            <b-table
                                class="table table-striped"
                                hover
                                :items="cotizaciones"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                @filtered="onFiltered"
                                :filter-included-fields="filterOn"
                            >
                                <template v-slot:cell(cliente)="data">
                                    <p>{{ data.item.cliente.NomAux }}</p>
                                </template>
                                <template v-slot:cell(numerosl)="data">
                                    <p>{{ data.item.numerosl }}</p>
                                </template>
                                <template v-slot:cell(numeropw)="data">
                                    <p>COT{{ data.item.id }}</p>
                                </template>
                                <template v-slot:cell(vendedor)="data">
                                    <p>{{ data.item.vendedor.name }}</p>
                                </template>
                                <template v-slot:cell(total)="data">
                                    <p>{{ '$' + formatPrecio(data.item.total) }}</p>
                                </template>
                                <template v-slot:cell(accion)="data">
                                    <div class="d-flex gap-2">
                                        <b-button class="mr-2" size="sm" variant="primary" @click="verCotizacion(data.item)">Ver detalle</b-button>
                                        <b-button class="mr-2 d-flex justify-content-center align-items-center" size="sm" variant="primary" @click="CopiarCotizacion(data.item)">
                                            <i class="bx bx-copy bx-sm"></i>
                                        </b-button>
                                        <b-button class="mr-2 d-flex justify-content-center align-items-center" size="sm" variant="primary" @click="EditarCotizacion(data.item)">
                                            <i class="bx bx-edit bx-sm"></i>
                                        </b-button>

                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" class="mt-2" ></b-pagination>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal para crear cotización -->
        <b-modal ref="ModalCrearCotizacion" :title="Cotizacion.id?'Editar Cotización':'Crear Cotización'" hide-footer size="xl">
            <form class="form-horizontal">
                <!-- Datos Generales de la Cotización -->
                <div class="col-md-12 mt-3 mb-3" ref="cotizacionHeader">
                    <!-- Logo alineado a la izquierda arriba -->
                    <div class="row mb-3">
                        <div class="col-md-12 text-left p-0">
                            <img src="/archivos_base/logo.png" style="height: 60px; object-fit: contain;">
                        </div>
                    </div>

                    <!-- Dos columnas debajo del logo -->
                    <div class="row d-flex align-items-start">
                        <!-- Columna izquierda: Datos de contacto -->
                        <div class="col-md-6 text-left p-0">
                            <p class="text-primary mb-1"><strong>Teléfono:</strong> 63 2 219881 - 63 2 204385</p>
                            <p class="text-primary mb-1"><strong>Dirección:</strong> Errázuriz 2066, Valdivia</p>
                            <p class="text-primary mb-1"><strong>Email:</strong> contacto@vamproden.cl</p>
                            <p class="text-primary mb-1"><strong>Web:</strong> www.vamproden.cl</p>
                        </div>

                        <!-- Columna derecha: Datos de cotización -->
                        <div class="col-md-6 text-left p-0">
                            <h5 class="mb-2">
                                <span class="text-primary">N° de Cotización:</span>
                                <span>{{Cotizacion.id?Cotizacion.numerosl:'---'}}</span>
                            </h5>
                            <h5 class="mb-2">
                                <span class="text-primary">Vendedor:</span>
                                <span>{{ Cotizacion.vendedor.name }}</span>
                            </h5>
                            <h5 class="mb-0">
                                <span class="text-primary">Fecha:</span>
                                <span>{{ Cotizacion.fecha }}</span>
                            </h5>
                        </div>
                    </div>
                </div>





                <div class="row">
                <!-- Segunda fila: 2 columnas -->
                    <div class="col-md-12">
                        <b-form-group
                            label-for="cliente"
                            label-cols-sm="12"
                            label-class="font-weight-bold mb-1"
                            class="mb-2 text-primary text-left">
                            <label for="cliente" class="font-weight-bold mb-1" style="font-size: 1.1rem;">Buscar Cliente:</label>
                            <v-select
                            id="cliente"
                            v-model="Cotizacion.cliente"
                            :options="ws_clientes"
                            label="nombre"
                            placeholder="🔍 Buscar por Nombre o RUT"
                            :filterable="true"
                            :reduce="cliente => cliente"
                            :get-option-label="cliente => `${cliente.NomAux} - ${cliente.CodAux}`"
                            style="height: 45px; font-size: 1rem;"
                            @input="onClienteSeleccionado"
                            />
                        </b-form-group>
                    </div>

                </div>
                <div class="row text-left mt-2">
                    <div class="col-12" v-if="Cotizacion.cliente">
                        <div class="p-3 rounded" style="background-color: #e7f3ff; border: 1px solid #b6d4fe;">
                            <div class="row">
                                <div class="col-md-6">
                                <!-- <p class="mb-1" ><strong class="text-primary">Persona Contacto:</strong> {{ Cotizacion.cliente.contacto }}</p> -->
                                <p class="mb-1" ><strong class="text-primary">Mail Contacto:</strong> {{ Cotizacion.cliente.Email }}</p>
                                <p class="mb-1"><strong class="text-primary"> Saldo vencido:</strong> {{ formatPrecio(saldo_pendiente)}}</p>
                                <p class="mb-1"><strong class="text-primary"> Saldo cliente:</strong> {{ formatPrecio(Cotizacion.cliente.SaldoCliente)}}</p>
                                <p class="mb-1"><strong class="text-primary"> Credito:</strong> {{ formatPrecio(Cotizacion.cliente.MontoCredito)}}</p>
                                </div>
                                <div class="col-md-6">
                                <p class="mb-1" v-if="Cotizacion.cliente.Bloqueado"><strong class="text-primary"> Estado:</strong> {{ Cotizacion.cliente.Bloqueado!='N'?'Bloqueado':'Habilitado' }}</p>
                                <p class="mb-1" v-if="Cotizacion.cliente.CondicionVenta"><strong class="text-primary">Condición de Venta:</strong> {{ Cotizacion.cliente.CondicionVenta }}</p>
                                </div>
                            </div>
                        </div>
                        <b-button size="sm" variant="primary" @click="verFacturas = !verFacturas" class="mb-2 mt-2">
                            {{ verFacturas ? 'Ocultar facturas' : 'Ver facturas (' + facturas_pendientes.length + ')' }}
                        </b-button>
                        <b-collapse v-model="verFacturas">
                            <b-table
                                :items="facturas_pendientes"
                                :fields="['documento', 'emision', 'vence', 'saldo']"
                                small
                                responsive
                                bordered
                                class="mb-2"
                            >
                                <template #cell(saldo)="data">
                                    {{ formatPrecio(data.item.saldo) }}
                                </template>
                            </b-table>
                        </b-collapse>
                    </div>
                </div>

                <!-- Descripción -->
                <div class="mt-4 mb-4 text-left">
                    <label for="descripcion" class="text-primary font-weight-bold"><strong>Detalles Cotización:</strong></label>
                    <b-form-textarea
                        id="descripcion"
                        v-model="Cotizacion.descripcion"
                        placeholder="Descripción general"
                        rows="4"
                        class="custom-textarea"
                    />
                </div>
            <!-- Tabla de Productos -->
            <div class="mb-4">
            <h4 class="text-center text-primary">Detalle de Productos</h4>

            <b-table
                responsive
                :items="Cotizacion.productos"
                :fields="[
                { key: 'N', label: 'N', thStyle: { width: '4%' }, thClass: 'text-primary' },
                { key: 'producto', label: 'Producto', thStyle: { width: '40%' }, thClass: 'text-primary' },
                { key: 'cantidad', label: 'Cantidad', thStyle: { width: '10%' }, thClass: 'text-primary text-center', tdClass: 'text-center align-middle' },
                { key: 'Stock', label: 'Stock', thStyle: { width: '8%' }, thClass: 'text-primary text-center', tdClass: 'text-center align-middle' },
                { key: 'precioUnitario', label: 'P. Unitario', thStyle: { width: '10%' }, thClass: 'text-primary text-center', tdClass: 'text-center align-middle' },
                { key: 'DescU', label: 'Desc. %', thStyle: { width: '10%' }, thClass: 'text-primary text-center', tdClass: 'text-center align-middle' },
                { key: 'total', label: 'Total', thStyle: { width: '10%' }, thClass: 'text-primary text-center', tdClass: 'text-center align-middle' },
                { key: 'acciones', label: '', thStyle: { width: '3%' }, tdClass: 'text-center align-middle' }
                ]"
                bordered
            >
                <!-- Producto -->
                <template v-slot:cell(producto)="data">
                <v-select
                    class="expandible-select"
                    :options="ws_productos"
                    label="producto"
                    :get-option-label="p => `${p.DesProd} - ${p.CodProd}`"
                    v-model="data.item.producto"
                    placeholder="Buscar por nombre o código"
                    @input="productoSeleccionado(data.index, $event)"
                />
                </template>

                <!-- Cantidad -->
                <template v-slot:cell(cantidad)="data">
                <b-form-input
                    v-model="data.item.cantidad"
                    type="number"
                    placeholder="Cantidad"
                    class="form-control no-spinner text-center"
                />
                </template>

                <!-- Stock -->
                <template v-slot:cell(Stock)="data">
                <p class="mb-0 text-center">{{ data.item.producto.Stock }}</p>
                </template>

                <!-- Precio Unitario -->
                <template v-slot:cell(precioUnitario)="data">
                <p class="mb-0 text-center">{{ formatPrecio(data.item.precio) }}</p>
                </template>

                <!-- Descuento -->
                <template v-slot:cell(DescU)="data">
                <b-form-input
                    v-model="data.item.DescU"
                    type="number"
                    placeholder="%"
                    class="form-control no-spinner text-center"
                    @input="limitarDescuento(data.item)"
                />
                </template>


                <!-- Total -->
                <template v-slot:cell(N)="data">
                    <p class="mb-0 text-center">
                        {{ data.index+1 }}
                    </p>
                </template>
                <template v-slot:cell(total)="data">
                    <p class="mb-0 text-center">
                        {{ formatPrecio(total_venta(data.item.cantidad, data.item.producto.PrecioVta, data.item.DescU)) }}
                    </p>
                </template>




                <!-- Botón para eliminar fila -->
                <template v-slot:cell(acciones)="data">
                <b-button variant="danger" size="sm" @click="quitarProductoPorItem(data.item)">
                    <span aria-hidden="true">&times;</span>
                </b-button>
                </template>

            </b-table>

            <!-- Botón de agregar producto -->
            <div class="mt-3">
                <b-button variant="primary" @click="agregarProducto">Agregar Producto</b-button>
            </div>
            </div>


                <!-- Total de la Cotización -->
                <div class="row justify-content-end mb-4 mt-4" >
                    <div class="col-md-4">
                        <div class="border p-3 bg-light text-primary">
                        <b-form-group label="Total Neto:" label-cols="6" label-class="text-left" label-for="totalNeto" class="mb-1">
                            <b-form-input id="totalNeto" :value="totalNeto" disabled class="text-right py-1" />
                        </b-form-group>

                        <b-form-group label="IVA 19%:" label-cols="6" label-class="text-left" label-for="totalIva" class="mb-1">
                            <b-form-input id="totalIva" :value="totalIva" disabled class="text-right  py-1" />
                        </b-form-group>

                        <b-form-group label="Total:" label-cols="6" label-class="text-left" label-for="totalConIva" class="mb-0">
                            <b-form-input id="totalConIva" :value="totalConIva" disabled class="text-right font-weight-bold py-1" />
                        </b-form-group>
                        </div>
                    </div>
                </div>
            </form>
            <div class="text-right">
                <b-button variant="secondary" @click="$refs.ModalCrearCotizacion.hide()">Cancelar</b-button>
                <b-button variant="success" @click="guardar_cotizacion()" :disabled="!Cotizacion.cliente || !Cotizacion.productos.length || Cotizacion.productos.some(p => !p.producto || !p.cantidad || p.cantidad <= 0)">Guardar</b-button>
            </div>
        </b-modal>

        <b-modal ref="ModalVerCotizacion" title="Detalle Cotización" size="lg">
  <div class="row mx-0 px-5 pt-4" ref="CotizacionContentPDF">

    <!-- Cabecera -->
    <div class="col-12 mb-3">
      <div class="row align-items-start mx-0 text-left">
        <div class="col-md-7 p-0">
          <img src="/archivos_base/logo.png" style="height: 50px; object-fit: contain;">
          <p class="text-primary mt-2 mb-0">
            <strong>Teléfono:</strong> 63 2 219881 - 63 2 204385<br>
            <strong>Dirección:</strong> Errázuriz 2066, Valdivia<br>
            <strong>Email:</strong> contacto@vamproden.cl<br>
            <strong>Web:</strong> www.vamproden.cl
          </p>
        </div>
        <div class="col-md-5 p-0">
          <p class="text-primary mb-1"><b>ID:</b> {{ Cotizacion.numerosl }}</p>
          <p class="text-primary mb-1"><b>Número Cotización:</b> COT{{ Cotizacion.id }}</p>
          <p class="text-primary mb-1"><b>Fecha Creación:</b> {{ Cotizacion.fecha }}</p>
        </div>
      </div>
    </div>

    <!-- Info Cliente/Vendedor -->
    <div class="col-12 mb-3">
      <h4 class="text-primary text-left">Detalle de Cotización</h4>
      <div class="row bg-light p-3 border mx-0 text-left">
        <div class="col-md-6 p-0 text-primary">
          <p class="mb-0"><b>Cliente:</b> {{ Cotizacion.cliente.NomAux }}</p>
          <p class="mb-0"><b>Rut:</b> {{ Cotizacion.cliente.CodAux }}</p>
          <p class="mb-0"><b>Condición de Venta:</b> {{ Cotizacion.cliente.CondicionVenta }}</p>
          <p class="mb-0"><b>Correo:</b> {{ Cotizacion.cliente.Email }}</p>
        </div>
        <div class="col-md-6 p-0 text-primary">
          <p class="mb-0"><b>Vendedor:</b> {{ Cotizacion.vendedor.name }}</p>
          <p class="mb-0"><b>Descripción:</b> {{ Cotizacion.descripcion }}</p>
        </div>
      </div>
    </div>

    <!-- Tabla productos -->
    <div class="col-12 mb-3">
      <p class="text-primary text-left"><b>Lista de Productos Cotizados:</b></p>
      <div class="table-responsive">
        <table class="table table-hover mb-0 cotizacion-table" style="border: 1px solid #21308F; font-size: 10px;">
          <thead class="bg-light text-center">
                <th style="border: 1px solid #21308F; width: 5%;">N</th>
                <th style="border: 1px solid #21308F; width: 12%;">Código</th>
                <th style="border: 1px solid #21308F; width: 48%;">Producto</th>
                <th style="border: 1px solid #21308F; width: 7%;">Cant</th>
                <th style="border: 1px solid #21308F; width: 10%;">P. Unitario</th>
                <th style="border: 1px solid #21308F; width: 6%;">%</th>
                <th style="border: 1px solid #21308F; width: 12%;">Total</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in Cotizacion.productos" :key="index" class="text-center">
              <td style="border: 1px solid #21308F;">{{ index + 1 }}</td>
              <td style="border: 1px solid #21308F;">{{ item.codigo }}</td>
              <td style="border: 1px solid #21308F;" class="text-left">{{ item.producto.DesProd || item.producto }}</td>
              <td style="border: 1px solid #21308F;">{{ item.cantidad }}</td>
              <td style="border: 1px solid #21308F;">{{ formatPrecio(parseInt(item.precio_unitario)) }}</td>
              <td style="border: 1px solid #21308F;">{{ item.DescU }}</td>
              <td style="border: 1px solid #21308F;">{{ formatPrecio(parseInt(item.total)) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Resumen -->
    <div class="col-12 resumen-cotizacion page-break mt-4 mb-2">
      <div class="row mx-0 text-left">
        <div class="col-md-6 text-primary p-0">
          <p><strong>Datos de transferencia:</strong></p>
          <p class="mb-1">Vamproden SpA</p>
          <p class="mb-1">76.962.948-3</p>
          <p class="mb-1">Banco Santander</p>
          <p class="mb-1">Cuenta Corriente: 73686610</p>
          <p class="mb-1">nfigueroa@vamproden.cl</p>
          <p class="mt-3"><strong>Link de pago Webpay:</strong><br>
            <a href="https://www.webpay.cl/company/27935" style="color: #0d6efd;">https://www.webpay.cl/company/27935</a>
          </p>
        </div>
        <div class="col-md-6 p-0">
          <div class="border p-3 bg-light">
            <p class="text-primary mb-1"><b>Total Neto:</b> {{ formatPrecio(parseInt(Cotizacion.total_neto)) }}</p>
            <p class="text-primary mb-1"><b>IVA:</b> {{ formatPrecio(parseInt(Cotizacion.iva)) }}</p>
            <p class="text-primary mb-1"><b>Total Cotización:</b> {{ formatPrecio(parseInt(Cotizacion.total)) }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>

    <!-- Modal footer buttons -->
    <template #modal-footer>
  <div class="w-100">
    <b-button variant="primary" class="float-left mr-2" @click="exportarPDF">
      <i class="bx bxs-file-pdf font-size-16 mr-1"></i> Descargar PDF
    </b-button>
    <b-button variant="primary" class="float-left" @click="consultaCorreoCotizacion(Cotizacion)">
      <i class="bx bxs-file-pdf font-size-16 mr-1"></i> Enviar PDF
    </b-button>
    <b-button variant="primary" class="float-right" @click="$refs.ModalVerCotizacion.hide()">Aceptar</b-button>
  </div>
</template>

</b-modal>


    </Layout>
</template>

<style>
/* Estilo para paginación activa */
.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #50a5f1;
}

/* Recuadro celeste */
.bg-light {
  background-color: #e7f3ff !important;
}

/* Bordes personalizados */
.border {
  border: 1px solid #b6d4fe !important;
  border-radius: 5px;
}

/* Negrita */
.font-weight-bold {
  font-weight: 600;
}

/* Textarea personalizado */
.custom-textarea {
  border: 1px solid #b6d4fe !important;
}

/* Tabla: evitar recorte de contenido */
.b-table td,
table td {
  overflow: visible !important;
  position: relative;
  z-index: auto;
}

/* Contenedores deben permitir overflow visible */
.table-responsive,
.card-body,
.card,
.row,
.col-md-12 {
  overflow: visible !important;
}

.tabla-productos tr {
        page-break-inside: avoid;
}

/* Estilo para desplegar select correctamente */
/* .expandible-select {
  position: relative;
  z-index: 999;
  width: 100% !important;
}

.expandible-select .vs__dropdown-toggle {
  width: 100% !important;
}

.avoid-break {
  page-break-inside: avoid !important;
}


.expandible-select .vs__dropdown-menu {
  position: fixed !important;
  z-index: 9999 !important;
  background-color: white;
  top: calc(100% + 8px) !important; /* separa el dropdown hacia abajo 
} 
*/
/* Estilos para mantener el dropdown sobre otros elementos */
/* .expandible-select {
  position: relative;
  width: 100%;
  z-index: 10;
} */

.cotizacion-table thead {
  display: table-header-group;
}
.cotizacion-table tfoot {
  display: table-footer-group;
}
.cotizacion-table tr {
  page-break-inside: auto;
  page-break-after: auto;
}

.page-break {
  page-break-before: always;
}

.avoid-break-inside {
  page-break-inside: avoid;
  break-inside: avoid;
}

.cotizacion-table-row {
  page-break-inside: avoid;
  break-inside: avoid;
}

thead {
  display: table-header-group;
}
tfoot {
  display: table-footer-group;
}


/* ::v-deep(.expandible-select .vs__dropdown-menu) {
  position: absolute !important;
  top: 100% !important;
  left: 0;
  width: 100% !important;
  z-index: 9999 !important;
  background-color: white;
  border: 1px solid #b6d4fe;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
} */

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
